var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({on, attrs}){return [(_vm.msg)?_c('v-icon',_vm._g(_vm._b({attrs:{"color":"third"}},'v-icon',attrs,false),on),[_vm._v(" mdi-help-circle-outline ")]):_vm._e()]}}])},[_c('span',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }